import { render, staticRenderFns } from "./BosNotificationBanner.vue?vue&type=template&id=211413d6"
import script from "./BosNotificationBanner.vue?vue&type=script&lang=js"
export * from "./BosNotificationBanner.vue?vue&type=script&lang=js"
import style0 from "./BosNotificationBanner.vue?vue&type=style&index=0&id=211413d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports